import React, { Component } from 'react'
import { Icon, Input, AutoComplete } from 'antd'
import cuid from 'cuid'
import PropTypes from 'prop-types'
import css from './index.scss'

const Option = AutoComplete.Option
const OptGroup = AutoComplete.OptGroup

class Autocomplete extends Component {
  state = {}
  renderOptions = (dataSource, groupData) => {
    if (this.props.renderCustomOptions) {
      return this.props.renderCustomOptions()
    }
    if (groupData) {
      return dataSource.map(group => (
        <OptGroup
          key={cuid()}
          label={group[this.props.groupDataTitle || 'title']}
        >
          {group[this.props.groupDataChildren || 'children'].map(opt => (
            <Option
              key={cuid()}
              value={opt[this.props.labelName || 'label']}
              data={opt}
            >
              {opt[this.props.labelName || 'label']}
            </Option>
          ))}
        </OptGroup>
      ))
    }
    return dataSource.map(opt => (
      <Option
        key={cuid()}
        value={opt[this.props.labelName || 'label']}
        data={opt}
      >
        {opt[this.props.labelName || 'label']}
      </Option>
    ))
  }


  render() {
    const { props } = this
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: this.props.containerWidth }}>
        {
          props.label ? (
            <span
              className={props.gray ?
                css.inputLabelGray : css.inputLabel}
            >{props.label}</span>
          ) : null
        }
        <div
          className={css['certain-category-search-wrapper']}
          style={{ width: this.props.width || 250, ...this.props.containerStyle }}
        >
          <AutoComplete
            className={`${css['certain-category-search']}`.concat(` ${this.props.className}`)}
            dropdownClassName={css['certain-category-search-dropdown']
              .concat(` ${this.props.overlayClassName}`)}
            dropdownMatchSelectWidth={false}
            // dropdownStyle={{ width: '100%' }}
            size="large"
            style={{ width: '100%' }}
            dataSource={this.renderOptions(props.data || [], props.groupData)}
            placeholder={props.placeholder || ''}
            optionLabelProp="value"
            filterOption={props.filterOption}
            onSelect={this.props.onSelect}
            defaultValue={this.props.defaultValue}
            allowClear={this.props.allowClear}
            value={this.props.value}
            onChange={this.props.onChange}
            onFocus={this.props.onFocus}
            onSearch={this.props.onSearch}
            disabled={this.props.disabled}
          >
            {
              this.props.children ? this.props.children : (
                <Input
                  suffix={
                    <Icon
                      type="search"
                      // className={`${css['certain-category-icon']}`.concat(` ${this.props.inputClassName}`)}
                      className={css['certain-category-icon']}
                    />
                  }
                  size="small"
                />
              )
            }
          </AutoComplete>
        </div>
      </div>
    )
  }
}

Autocomplete.propTypes = {
  onSelect: PropTypes.func,
  defaultValue: PropTypes.string,
  allowClear: PropTypes.bool,
  value: PropTypes.string,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
}
Autocomplete.defaultProps = {
  onSelect: () => {},
  defaultValue: '',
  allowClear: false,
  value: '',
  onFocus: () => {},
  onChange: null,
}

export default Autocomplete
